/* eslint-disable import/prefer-default-export */
import React from 'react';

import MatchedMap from 'utilities/src/matchedMap';

import { IconEnum } from '../../data/MenuItem';

import BairesDevLogo from './icons/BairesDevLogo';
import DedicatedTeamsIcon from './icons/DedicatedTeamsIcon';
import SoftwareOutsourcingIcon from './icons/SoftwareOutsourcingIcon';
import StaffAugmentationIcon from './icons/StaffAugmentationIcon';

export const flyoutIcons = new MatchedMap([
  [IconEnum.BairesDev, <BairesDevLogo />],
  [IconEnum.DedicatedTeams, <DedicatedTeamsIcon />],
  [IconEnum.StaffAugmentation, <StaffAugmentationIcon />],
  [IconEnum.SoftwareOutsourcing, <SoftwareOutsourcingIcon />],
]);
